import React from 'react';

const WorkCard = ({
    status,
    name,
    description,
    tech = [],
    link,
    linkText,
    appStore,
    img,
    video,
    isYC = false,
    stats = null,
    className = '',
}) => {
    const hasMedia = (video || img) && !isYC;

    return (
        <article
            className={`group bg-white border border-[#E5DFD8] p-8 transition-colors md:p-10 hover:border-[#A68B6A] ${
                hasMedia ? 'grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12' : ''
            } ${className}`}
        >
            {/* Content */}
            <div className="flex flex-col justify-between">
                <div>
                    <p
                        className="uppercase mb-6 text-[#A68B6A]"
                        style={{ fontSize: '0.65rem', letterSpacing: '0.15em' }}
                    >
                        {status}
                    </p>
                    <h2
                        className="mb-3 text-[#2C2824]"
                        style={{ fontFamily: "'Cinzel', serif", fontWeight: 400, fontSize: '1.5rem', letterSpacing: '0.04em' }}
                    >
                        {name}
                    </h2>
                    <p className="mb-6 text-[#8C8580]" style={{ fontSize: '0.9rem', lineHeight: 1.7 }}>{description}</p>
                    {tech.length > 0 && (
                        <div className="mb-6 flex flex-wrap gap-2">
                            {tech.map((t) => (
                                <span key={t} className="border border-[#E5DFD8] px-3 py-1 text-[#8C8580]" style={{ fontSize: '0.75rem' }}>
                                    {t}
                                </span>
                            ))}
                        </div>
                    )}
                    {isYC && stats && (
                        <div className="mb-6 grid grid-cols-2 gap-4 sm:grid-cols-3">
                            {stats.map((stat, i) => (
                                <div key={i} className="border border-[#E5DFD8] p-4">
                                    <p className="text-2xl text-[#A68B6A]" style={{ fontFamily: "'Cinzel', serif" }}>{stat.value}</p>
                                    <p className="text-[#8C8580] mt-1" style={{ fontSize: '0.75rem' }}>{stat.label}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="flex flex-wrap gap-3">
                    {link && (
                        <a
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-[#2C2824] px-6 py-2.5 text-xs font-medium uppercase tracking-wider text-white transition-all hover:bg-[#A68B6A]"
                        >
                            {linkText} →
                        </a>
                    )}
                    {appStore && (
                        <a
                            href={appStore}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="border border-[#E5DFD8] px-6 py-2.5 text-xs font-medium uppercase tracking-wider text-[#2C2824] transition-all hover:border-[#A68B6A] hover:text-[#A68B6A]"
                        >
                            App Store →
                        </a>
                    )}
                </div>
            </div>

            {/* Media — video if available, else image */}
            {hasMedia && (
                <div className="flex items-center justify-center">
                    <div className="overflow-hidden bg-[#F5F0EA] w-full max-w-[200px] max-h-[360px]">
                        {video ? (
                            <video
                                src={video}
                                poster={img}
                                autoPlay
                                muted
                                loop
                                playsInline
                                className="w-full h-full object-contain"
                            />
                        ) : (
                            <img
                                src={img}
                                alt={`${name} screenshot`}
                                className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-[1.02]"
                                width={200}
                                height={360}
                                loading="lazy"
                            />
                        )}
                    </div>
                </div>
            )}
        </article>
    );
};

export default WorkCard;
